module.exports = __webpack_public_path__ + "owl.jpg?ab9a004ad0277a6ac4c54b79eaf820c1";